export default __webpack_public_path__ + "static/2244-66d495028140ef5b155c07dacd202820.gif";